var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgParking = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24 0H0v24h24zm-2 2v20H2V2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 6v13H8V6z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 6c2.2 0 4 1.8 4 4 0 2.1-1.7 3.9-3.8 4H9v-2h3c1.1 0 2-.9 2-2s-.8-1.9-1.9-2H9V6z"
})));
export default SvgParking;